import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const handleScrollToWork = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('work');
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="min-h-screen flex flex-col justify-center px-6 md:px-12 pt-32 pb-24" data-id="element-144">
      <div className="max-w-6xl mx-auto w-full" data-id="element-145">
        <div className="flex flex-col-reverse lg:flex-row lg:items-center lg:gap-16 mb-20" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="lg:flex-1" data-id="element-147">
            <h1 className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold text-primary leading-[1.05] tracking-tight mb-8" data-id="element-148">
              Karan Dhir
            </h1>

            <h2 className="text-2xl md:text-3xl text-primary font-medium tracking-tight mb-6 max-w-2xl leading-snug" data-id="element-149">
              I build the AI platforms, teams, and governance systems that turn
              models into enterprise decisions.
            </h2>

            <p className="text-secondary text-lg md:text-xl max-w-2xl leading-relaxed mb-10" data-id="element-150">
              From $1.2B marketing allocation systems at Genentech to
              billion-scale recommendation engines at Amazon, I specialize in
              the organizational and technical infrastructure that makes AI work
              at scale.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-151">
              <a href="#work" onClick={handleScrollToWork} className="inline-flex items-center justify-center px-8 py-4 text-sm font-semibold text-dark bg-gold hover:bg-gold-hover rounded-full transition-colors w-full sm:w-auto" data-id="element-152">
                View Case Studies
              </a>
              <a href="https://www.linkedin.com/in/dhirkaran/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-sm font-semibold text-primary border border-border hover:border-gold hover:text-gold rounded-full transition-colors w-full sm:w-auto" data-id="element-153">
                Connect on LinkedIn
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex justify-center mb-12 lg:mb-0 shrink-0" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/wjewJy4h9doZeRxAp9y6hv/Headshot.jpg" alt="Karan Dhir" className="w-56 h-56 md:w-72 md:h-72 rounded-2xl object-cover border border-border shadow-lg shadow-black/30" data-id="element-155" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="pt-10 border-t border-border/50" data-id="element-156">
          <div className="text-xs font-medium text-secondary/70 uppercase tracking-widest mb-6" data-id="element-157">
            Previously At
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-4 text-lg md:text-xl font-medium text-secondary" data-id="element-158">
            <span data-id="element-159">Genentech (Roche)</span>
            <span className="text-border hidden sm:inline-block" data-id="element-160">•</span>
            <span data-id="element-161">Walmart</span>
            <span className="text-border hidden sm:inline-block" data-id="element-162">•</span>
            <span data-id="element-163">Amazon</span>
            <span className="text-border hidden sm:inline-block" data-id="element-164">•</span>
            <span data-id="element-165">Enfusion</span>
          </div>
        </motion.div>
      </div>
    </section>;
}